import { errorSVG, successSVG } from '../../lib/allCustomSVGs';
import MessageBanner from '../../components/messageBanner/MessageBanner';
import { useTranslation } from 'react-i18next';
import { usePaymentConfirmation } from '../../lib/plan-lock/usePaymentConfirmation';
import { useNavigate } from 'react-router-dom';

const StripeSubscriptionSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // The payment went through: a locked account asks central-api for the plan
  // state again so it opens up without a new sign-in. Stripe's confirmation
  // can land a moment after this page, hence a few attempts.
  const payment = usePaymentConfirmation(true);

  // Still locked after asking: the confirmation has not arrived yet. Saying
  // "subscribed" here would lead back to the plans, and to paying twice.
  if (payment.state !== 'idle') {
    return (
      <div data-testid='payment-processing'>
        <MessageBanner
          title={t('PlanLock-PaymentProcessingTitle')}
          subTitle={
            payment.state === 'checking'
              ? t('PlanLock-CheckingPayment')
              : t('PlanLock-PaymentProcessing')
          }
          icon={errorSVG}
          btnTitle={t('PlanLock-CheckAgain')}
          onSelect={payment.checkAgain}
          isLoading={payment.state === 'checking'}
          success={false}
        />
      </div>
    );
  }

  return (
    <>
      <MessageBanner
        title={t('StripeSubscriptionSuccessMainText')}
        subTitle={t('StripeSubscriptionSuccessSubText')}
        icon={successSVG}
        btnTitle='Ok'
        onSelect={() => {
          if (window?.opener) {
            window.opener?.location?.reload();
            window.close();
          } else {
            navigate('/');
          }
        }}
        success={true}
      />
    </>
  );
};

export default StripeSubscriptionSuccess;
